import React from 'react'
import View from './View/outright-payment-view'
import { PaymentProvider } from 'src/hooks/use-payment-context'

export const OutrightPayment = () => (
  <PaymentProvider>
    <View />
  </PaymentProvider>
)
